import { theme } from '@clickcease/cc-client-components-lib'

export const TREND_CATEGORIES = {
  INVALID_RATE: 'INVALID_RATE',
  VISITS: 'VISITS',
} as const

export const DATA_INDEX = {
  DATE: 0,
  CATEGORY: 0,
  VALUE: 1,
} as const

export const THREAT_GROUPS_TO_DISPLAY = {
  INVALID_BOT_ACTIVITY: {
    value: 'invalid bot activity',
    color: theme.colors.chart1.value,
  },
  INVALID_MALICIOUS_ACTIVITY: {
    value: 'invalid malicious activity',
    color: theme.colors.chart2.value,
  },
  INVALID_SUSPICIOUS_ACTIVITY: {
    value: 'invalid suspicious activity',
    color: theme.colors.charts3.value,
  },
  MARKETING_OPTIMIZATION_RULES: {
    value: 'marketing optimization rules',
    color: theme.colors.chart4.value,
  },
} as const

export const THREAT_GROUPS_COLORS: Record<string, string> = {
  'invalid bot activity': theme.colors.chart1.value,
  'invalid malicious activity': theme.colors.chart2.value,
  'invalid suspicious activity': theme.colors.charts3.value,
  'marketing optimization rules': theme.colors.chart4.value,
}

export type ALLOWED_THREAT_GROUPS_NAMES = Pick<
  (typeof THREAT_GROUPS_TO_DISPLAY)[keyof typeof THREAT_GROUPS_TO_DISPLAY],
  'value'
>['value']

export const NEW_ALLOWED_THREAT_GROUPS = {
  INVALID_BOT_ACTIVITY: {
    value: 'Invalid Bot Activity',
    color: theme.colors.chart1.value,
  },
  INVALID_MALICIOUS_ACTIVITY: {
    value: 'Invalid Malicious Activity',
    color: theme.colors.chart2.value,
  },
  INVALID_SUSPICIOUS_ACTIVITY: {
    value: 'Invalid Suspicious Activity',
    color: theme.colors.charts3.value,
  },
  MARKETING_OPTIMIZATION_RULES: {
    value: 'Marketing optimization rules',
    color: theme.colors.chart4.value,
  },
} as const

export type NEW_ALLOWED_THREAT_GROUPS_NAMES = Pick<
  (typeof NEW_ALLOWED_THREAT_GROUPS)[keyof typeof NEW_ALLOWED_THREAT_GROUPS],
  'value'
>['value']
